<!--
================================================
Un composant permettant de filter la report view par projet

Url d'accès : http://localhost:8080/fr/cronocloud-inc/reports/summary



* FONCTIONNEMENT :

    Lorsque l'on filtre un projet dans la liste, les timerecords correspondants sont inclus dans les résultats de la ReportsView.
    //IMPORTANT : Ce sont les paramètres d'url qui vont faire que la view report va charger/filtrer les données


LIMITATION DU COMPOSANT :


================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="ProjectFilterComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}"  v-click-outside="onClickOutside">
        <div class="selector" >
            <div class="count" v-show="filterCount >= 1">{{filterCount}}</div>

            <div class="opener" v-on:click="toggleList()" v-bind:title="$t('filtrerParProjet')">
                <span><font-awesome-icon class="icon iconType is-pulled-left" :icon="['far', 'folder-open']"/></span>
                <span class="text ">{{$t('projet')}}</span>
                <span><font-awesome-icon class="icon is-pulled-right chevron " :icon="['fas', 'chevron-down']"/></span>
            </div>

            <div class="list" v-show="listVisibility">
                <ul>
                    <div class="loaderZone" v-if="componentIsReady ==false">
                        <div class="txt">{{$t('chargementDesProjets')}}...</div>
                        <spinner-loader-comp v-bind:loading-txt="$t('chargementDesProjets')+'...'"></spinner-loader-comp>
                    </div>
                    <div v-else class="filterContent">
                        <li class="quickSelect">
                            <a class="all" v-on:click="selectAll(), updateCount(),emitFilterState()">{{$t('tous')}}</a> |
                            <a class="none" v-on:click="unSelectAll(), updateCount(),emitFilterState()">{{$t('aucun')}}</a>
                        </li>

                        <li class="noRelatedEntries">
                            <label class="checkbox" v-on:change="updateCount(),emitFilterState()">
                                <input type="checkbox" v-model="noRelatedFilter">{{$t('PointagesSansProjet')}}
                            </label>
                        </li>

                        <li><h3>{{$t('projets')}}</h3></li>
                        <li v-for="(project,index) in projects" v-bind:key="project.slug"
                            v-bind:class="'project_'+index + ' project_'+project.slug" v-show="showOnly(project)">
                            <label class="checkbox" v-on:change="updateCount(),emitFilterState(), updateProjectsFiltered(project)">
                                <input type="checkbox" v-bind:class="'cbox_'+project.slug"   v-model="project.isFiltered">
                                    <font-awesome-icon class="icon" :icon="['far', 'folder-open']" v-bind:style="{color:'#'+project.color}"/>
                                {{project.name}}
                            </label>
                        </li>

                    </div>


                    <div class="additionalFilter">
                        <span class="">{{$t('afficherLesProjets')}} </span> : <br>
                        <a class="active" v-on:click="archiveDisplayRule='active'"
                           v-bind:class="{'activeLInk':archiveDisplayRule=='active'}">{{$t('actifs')}}</a> |
                        <a class="archived" v-on:click="archiveDisplayRule='archived'"
                           v-bind:class="{'activeLInk':archiveDisplayRule=='archived'}">{{$t('archivés')}}</a>
                        | <a class="all" v-on:click="archiveDisplayRule='all'"
                             v-bind:class="{'activeLInk':archiveDisplayRule=='all'|| archiveDisplayRule== null}">{{$t('tous')}}</a>
                    </div>


                </ul>
            </div>



        </div>



    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SpinnerLoaderComp from "../SpinnerLoaderComp";
    import SentryMixin from "../../mixins/SentryMixin";
    import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin";
    import InterceptorMixin from "../../mixins/InterceptorMixin";
    import _ from "lodash";
    import vClickOutside from 'v-click-outside'

    export default {
        name: 'ProjectFilterComp',
        components: {SpinnerLoaderComp},
        directives: {
          clickOutside: vClickOutside.directive,
        },
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin],
        data: function () {
            return {
                userSlug: JSON.parse(this.$cookie.get('auth')).userSlug,
                listVisibility: false, // bool la visibilité de la liste
                projects : [], // la liste projets (accessibles à l'user) à afficher dans le filtre
                projectsFiltered: [], // array, contient les slug projets sélectionnés dans le filtre
                componentIsReady : false, // indique quand le composant est prêt à être affiché
                filterCount: 0, //int le nombre d'éléments à filter,
                archiveDisplayRule: 'active', // string, (all|archived|active) la règle pour afficher les projets archivés/actifs ou tous
                noRelatedFilter: false //bool, indique s'il faut inclure les task tr sans projet

            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                themeToDisplay: state => state.app.themeToDisplay

            }),
            //----------------------------------------------
        },
        watch: {

            // maj du param d'url 'pjctArchShow' quand archiveDisplayRule change
            archiveDisplayRule: function () {
                this.$router.push({ query: { ...this.$route.query, pjctArchShow: this.archiveDisplayRule}});
            },

            // maj du param d'url 'pjctNoRel' quand noRelatedFilter change
            noRelatedFilter: function () {
                let value
                switch (this.noRelatedFilter) {
                    case  true: value = '1'; break;
                    case  false: value = '0' ; break;
                    default:break;
                }
                this.$router.push({ query: { ...this.$route.query, pjctNoRel: value}});
            },
        },


        methods: {

          /* Masque le filtre lorsque l'on clique en dehors*/
          onClickOutside (event) {
            this.hideList()
          },

            /*
                Stockage de l'état du filtre dans le store
                (Avec les valeurs de this.noRelatedFilter & this.projectsFiltered)
                Sert à updater les critères de tri dans ReportsView
             */
            emitFilterState() {
                this.$store.commit('UpdateReportsViewFilterRulesProject', {
                    noRelated: this.noRelatedFilter,
                    projects2Filter: this.projectsFiltered
                });

            },

            toggleList(){
                if(this.listVisibility==true){
                    this.hideList()
                }
                else {
                    this.showList()
                }
            },

            showList(){
                this.listVisibility = true;
            },
            hideList(){
                this.listVisibility = false;
            },

            /**
             * Récupère les projets accessibles pour l'utilisateur.
             *
             * @param String filter | une chaîne pour filtrer par nom des projets ET clients
             */
            loadProjects(filter) {
                let self = this;
                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/users/${self.userSlug}/projects`,
                    {
                        params: {
                            filter: filter,
                            sort: 'desc', // on récupère les plus récents en premier
                            archive: 'all', // on récupère les projets archivés + actifs
                        },
                        headers: {Authorization: self.$auth.header()}
                    }
                )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on injecte une propriété 'isFiltered' dans chaque projets (qui sert à calculer filterCount et à selectionner le projet dans le filtrage)
                        let projects = []
                        response.data.forEach(function (value) {
                            value.isFiltered = false;
                            projects.push(value);
                        })
                        self.projects =  projects
                        self.initConfigFromUrl()
                        self.componentIsReady = true
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0033'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$mixpanel.track('global error displayed', {"id": errorCode,"detail": "error fetching projects"})
                          self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching projects', 'fatal': false})

                          self.$sentry.captureMessage(`Error ${errorCode} > "error fetching projects : ${error}`, 'error')

                        }
                    })
                    .then(() => {
                        // toujours exécuté
                    })
            },


            /**
             * Calcul le nombre total d'éléments cochés dans le filtre.
             */
            updateCount() {
                let total = 0;
                this.projects.forEach(function (item) {
                    if (item.isFiltered) {
                        total++
                    }
                });
                if (this.noRelatedFilter){total = total +1}
                this.filterCount = total
                this.$root.$emit('filter_tag_count_update',total)
            }

            /*
            * Ajoute le slug du projet passé en paramètre dans le tableau contenant les slugs des projets sélectionnés dans le filtre.
            **/
            ,updateProjectsFiltered(project){
                    if (project.isFiltered) {
                        // ajoute le projet à la liste des projets filtrés
                        this.projectsFiltered.push(project.slug)
                    }
                    else{
                        // supprime le projet de la liste des projets filtrés
                        _.pull(this.projectsFiltered,project.slug)
                    }

                    // maj du param d'url pjctProjects dans l'url
                    if(this.projectsFiltered.length==0){
                        this.$router.push({ query: {...this.$route.query, pjctProjects: null}});
                    }
                    else{
                        this.$router.push({ query: {...this.$route.query, pjctProjects: this.$qs.stringify(this.projectsFiltered)}});

                    }
            }

            /*
             * Sélectionne tous les éléments dans la liste
             */
            ,selectAll(){
                this.projects.forEach(function (item) {
                    item.isFiltered = true
                });
                this.noRelatedFilter = true
            }

            /*
             * Désélectionne tous les éléments dans la liste
             */
            ,unSelectAll(){
                this.projects.forEach(function (item) {
                    item.isFiltered = false
                });
                this.noRelatedFilter = false
            }

            /*
            * Gère l'affichage des projets selon la prop isArchived
            * project Obj
            */
            ,showOnly(project){
                switch (this.archiveDisplayRule) {
                    case  'active':
                        if(project.isArchived == false){return  true}
                        break;

                    case 'archived':
                        if(project.isArchived == true){return  true}
                        break;

                    case 'all':
                    default:
                        return true

                }
            },

            /**
             * Réinitialise le composant à sa valeur d'origine (désactive tous les filtres)
             */
            resetFilter(){
                this.filterCount= 0;
                this.unSelectAll();
                this.archiveDisplayRule='active';
                this.projectsFiltered = []

                // vidage des projets dans le store (permettra de reset le filtrage par projet dans la reportView)
                this.$store.commit('UpdateReportsViewFilterRulesProject', {
                    noRelated: null,
                    projects2Filter: []

                });

                //vidage des projets dans l'url
                this.$router.push({ query: { ...this.$route.query, pjctProjects: null}});

            }



            /*
             Configure le filtre en fonction des paramètres d'url
             */
            , initConfigFromUrl() {

                // 1. configuration de l'affichage des projets archivés ou non, si pjctArchShow est fournit dans l'url on l'utilise pour configurer les filtre
                if (this.$route.query.pjctArchShow != null) {
                    this.archiveDisplayRule = this.$route.query.pjctArchShow
                }
                // sinon on hydrate le param d'url avec la valeur par défaut de archiveDisplayRule
                else {

                  this.$router.replace({query: {...this.$route.query, pjctArchShow: this.archiveDisplayRule}}
                  );
                }

                // 2. configuration de l'affichage des tr sans projets, si pjctNoRel est fournit dans l'url on l'utilise pour configurer le filtre
                if (this.$route.query.pjctNoRel != null) {

                    (this.$route.query.pjctNoRel=='1') ? this.noRelatedFilter = true : this.noRelatedFilter = false
                }

                // 3. configuration des projets à filtrer
                // sélection des projets passés dans l'url
                let projectsInUrl = this.$qs.parse(this.$route.query.pjctProjects)

                if (_.size(projectsInUrl) > 0) {

                    // itération sur tous les slug des projets dans l'url
                    for (let [key] of Object.entries(projectsInUrl)) {

                        // pour chaque projet dans l'url, on active isFiltered dans le projet correspondant dans projects
                        let self = this
                        this.projects.forEach(function (item) {
                            if (projectsInUrl[key] == item.slug) {
                                item.isFiltered = true

                                // pour chaque projet dans l'url, on ajoute son slug dans projectsFiltered
                                self.projectsFiltered.push(item.slug)
                            }
                        })

                    }

                }

                this.updateCount()

            }
        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

            //chargement initial des projets
             this.loadProjects()

            // écoute de l'évent 'reinit_filters' emit depuis FiltersComp
            this.$root.$on('reinit_filters', () => {
                this.resetFilter()
            })

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/


        #ProjectFilterComp{

          // les styles appliqués ici sont ceux spécifique à ce filtre (sinon les styles communs sont dans FiltersComp)

          .filterContent {
            min-width: 15rem !important;
          }
          //////////////////////////////////////
          // DARK UI ///////////////////////////
          &.darkMode {

          }
        }
</style>
